import { useTranslation } from "react-i18next";

import { BankOutlined, CalendarOutlined, DownOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Card, Col, Dropdown, Flex, FloatButton, Menu, Row, Space, Tabs, Tag, Button } from "antd";

function minitag(status) {
    switch (status) {
        case "Approved":
            return (
                <Tag color="success"  >{status}</Tag>
            )
        case "Cancelled":
            return (<Tag color="error" >{status}</Tag>)
        case "Rejected":
            return (<Tag color="error" >{status}</Tag>)
        case "คำขอถูกยกเลิก":
            return (<Tag color="error" >{status}</Tag>)
        case "อนุมัติ":
            return (<Tag color="success" >{status}</Tag>)
        case "อนุมัติคำขอ":
            return (<Tag color="success" >{status}</Tag>)
        case "ยกเลิกคำขอ":
            return (<Tag color="error" >{status}</Tag>)
        case "คำขอถูกปฎิเสธ":
            return (<Tag color="error" >{status}</Tag>)
        default:
            return (<Tag color="processing" >{status}</Tag>)
    }
}

const items = [
    {
        key: '1',
        label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com">
                1st menu item
            </a>
        ),
    },
    {
        key: '2',
        label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.aliyun.com">
                2nd menu item
            </a>
        ),
    },
    {
        key: '3',
        label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.luohanacademy.com">
                3rd menu item
            </a>
        ),
    },
];
function ExpenseHome({
    expenseList = [],
    expenseById = {},
    getModal = () => { },
    getExpenseById = () => { },
    getExpenseDetail = () => { },
    onCreate = () => { },
    onChange = () => { },
    onPaid = () => { }
}) {
    const renderMenuItem = item => {
        return (
            <Menu.Item
                key={item?.txnExpenseRequestId}
                title={item?.subject}
                onClick={() => getExpenseById(item?.txnExpenseRequestId)}

            >
                <Flex justify="space-between">
                    <Col span={15}>
                        <span>{item?.subject}</span>
                    </Col>
                    <Col span={9}>
                        {minitag(i18n.language === 'en' ? item?.approveStatusEn : item?.approveStatus)}
                    </Col>
                </Flex>
                {/* <Row>
                    <Col span={5}>{item?.subject}</Col>
                    <Col span={10}></Col>
                    <Col span={9}>{minitag(i18n.language === 'en' ? item?.approveStatusEn : item?.approveStatus)}</Col>
                </Row> */}
            </Menu.Item>
        );
    };

    const { t, i18n } = useTranslation();
    const MENU = [
        {
            label: t("expense.my-expense"),
            key: "myExpense"
        },
        {
            label: t("expense.financial"),
            key: "financial",
        },
        {
            label: t("expense.all-expense"),
            key: "allExpense",
        }
    ]
    return (
        <>
            {getModal()}
            <Row justify='space-between' gutter={[16, 16]}>
                <Col span={7} >
                    <Card
                        bordered={40}
                        style={{
                            width: "100%",
                            backgroundColor: 'white',
                            height: '500px',
                        }}

                    >
                        <Row>
                            <Flex>
                                <Flex>
                                    <Tabs
                                        defaultActiveKey="myExpense"
                                        type="card"
                                        size="small"
                                        tabBarStyle={{
                                            display: 'flex'
                                        }}
                                        items={MENU.map((menuItem) => {
                                            return {
                                                label: menuItem?.label,
                                                key: menuItem?.key,
                                            };
                                        })}
                                        // className={styles.tabButton}
                                        onChange={(values) => {
                                            onChange(values)
                                        }}

                                    />
                                </Flex>
                            </Flex>
                        </Row>
                        {/* <Row >
                            <Col span={1}> </Col>
                            <Col span={23}>
                                <Tabs
                                    defaultActiveKey="myExpense"
                                    type="card"
                                    size="small"
                                    tabBarStyle={{
                                        tabSize: "100%"
                                    }}
                                    items={MENU.map((menuItem) => {
                                        return {
                                            label: menuItem?.label,
                                            key: menuItem?.key,
                                        };
                                    })}
                                    // className={styles.tabButton}
                                    onChange={(values) => {
                                        onChange(values)
                                    }}

                                />
                            </Col>
                        </Row> */}
                        {/* <Row style={{ marginTop: 20, justifyContent: "end" }}>
                            <Dropdown
                                menu={{
                                    items,
                                }}
                                placement="bottomRight"
                                arrow
                            >
                                <Button style={{ borderRadius: "20rem" }}><CalendarOutlined />{t('expense.label.create-date')}<DownOutlined /></Button>
                            </Dropdown>
                        </Row> */}

                        <Row style={{ marginTop: 20 }}>
                            <Col span={24}>
                                <div style={{ height: '250px', overflowY: 'scroll' }}>
                                    <Menu>
                                        {expenseList?.map(item => renderMenuItem(item))}
                                    </Menu>
                                </div>
                            </Col>

                        </Row>
                        <Row justify='end' style={{
                            marginTop: 10,
                            marginRight: 10
                        }}>
                            <FloatButton
                                icon={<PlusCircleOutlined />}
                                type="primary"
                                style={{
                                    position: 'sticky',
                                }}

                                onClick={() => onCreate()}
                            />
                        </Row>
                    </Card>

                </Col>
                <Col span={17}>
                    {expenseById?.txnExpenseRequestId && (
                        getExpenseDetail()
                    )}
                </Col >

            </Row >
            {expenseById?.txnExpenseRequestId && expenseById?.approveStatusEn !== 'Paid' && (
                <Row justify='end'>
                    <Button
                        htmlType="submit"
                        type="primary"
                        size="500px"
                        onClick={() => { onPaid() }}

                    >
                        {t("expense.mark-as-paid")}
                    </Button>
                </Row>

            )}



        </>
    );
};

export default ExpenseHome;
